module.exports = __webpack_public_path__ + "img/Powered_by_StandApp_W.c4285544.svg";